// Import Swiper core and required modules
import Swiper from 'swiper';
import { Navigation, Pagination } from 'swiper/modules';

document.addEventListener('DOMContentLoaded', () => {
    const swiperContainer = document.querySelector('.boxes .boxes-swiper');

    if (!swiperContainer) {
        return;
    }

    const boxesSwiper = new Swiper(swiperContainer, {
        modules: [Navigation, Pagination],
        slidesPerView: 1,
        spaceBetween: 20,
        loop: false,
        speed: 600,
        navigation: {
            nextEl: '.boxes .swiper-button-next',
            prevEl: '.boxes .swiper-button-prev',
        },
        pagination: {
            el: '.boxes .swiper-pagination',
            clickable: true,
        },
        breakpoints: {
            640: {
                slidesPerView: 2,
                spaceBetween: 20,
            },
            768: {
                slidesPerView: 2,
                spaceBetween: 24,
            }
        }
    });
});